import { useState, useCallback } from "react";
import axios from "axios";

import { getAuthorizationToken } from "@/auth/tokenStore";

export const useOpposingCounsel = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const origin = process.env.REACT_APP_BACKEND_URL;
  const token = getAuthorizationToken();

  const fetchOpposingCounsel = useCallback(
    async (currentCase, client) => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(`${origin}/api/client/opposingcounsel/`, {
          params: {
            for_case: currentCase || "",
            for_client: client || "",
          },
          headers: {
            Authorization: token,
          },
        });
        if (response.status === 200) {
          setData(response.data);
        }
      } catch (err) {
        setError(err.message);
        console.error("Error fetching opposing counsel:", err);
      } finally {
        setLoading(false);
      }
    },
    [origin, token]
  );

  const deleteOpposingCounsel = useCallback(
    async (counselId) => {
      try {
        const response = await axios.delete(
          `${origin}/api/defendants/delete_opposing_counsel/${counselId}/`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        return response.status === 204;
      } catch (err) {
        console.error("Error deleting counsel:", err);
        throw err;
      }
    },
    [origin, token]
  );

  return {
    data,
    loading,
    error,
    fetchOpposingCounsel,
    deleteOpposingCounsel,
  };
};

export const useCounselTypes = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const origin = process.env.REACT_APP_BACKEND_URL;
  const token = getAuthorizationToken();

  const fetchCounselTypes = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${origin}/api/defendants/counsel_types/`, {
        headers: {
          Authorization: token,
        },
      });
      setData(response.data);
    } catch (err) {
      setError(err.message);
      console.error("Error fetching counsel types:", err);
    } finally {
      setLoading(false);
    }
  }, [origin, token]);

  return {
    data,
    loading,
    error,
    fetchCounselTypes,
  };
};
